// buildTripFlight — pure mapping of flightInfo into the trip-flight payload.
//
// Extracted verbatim from `FlightLookup.js` (the body of `handleAddFlight` that
// constructs `tripFlight`) as part of the behavior-preserving refactor
// (issue #240). This is the normalized object emitted to `onFlightFound`: the
// `flightId` is `${flightInfo.airline}${flightInfo.flightNumber}`, gate/terminal
// fields fall back to `null`, `status` defaults to `'scheduled'`, and
// `aircraft` falls back to `null`.
//
// Field mapping and fallbacks are reproduced exactly. The source guarded the
// emit path with `if (!flightInfo || !onFlightFound) return;` BEFORE building
// the payload; that guard is a container/side-effect concern (it gates the
// callback), so it stays in the hook/container. This pure builder mirrors only
// the object construction, which the source reached only with a defined
// `flightInfo`.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Builds the trip-flight payload emitted via `onFlightFound`.
 *
 * @param {Object} flightInfo - The resolved flightInfo object.
 * @returns {Object} The normalized trip-flight object.
 */
export function buildTripFlight(flightInfo) {
  // Convert flight info to trip flight format
  const flightId = `${flightInfo.airline}${flightInfo.flightNumber}`;

  return {
    flightId: flightId,
    airline: flightInfo.airline,
    flightNumber: flightInfo.flightNumber,
    departureAirport: flightInfo.departureAirport,
    arrivalAirport: flightInfo.arrivalAirport,
    departureTime: flightInfo.departureTime,
    arrivalTime: flightInfo.arrivalTime,
    departureGate: flightInfo.departureGate || null,
    departureTerminal: flightInfo.departureTerminal || null,
    arrivalGate: flightInfo.arrivalGate || null,
    arrivalTerminal: flightInfo.arrivalTerminal || null,
    status: flightInfo.status || 'scheduled',
    aircraft: flightInfo.aircraftType || null
  };
}

export default buildTripFlight;
